export const colors = {
    white: "#FFF",
    green4: "#65AC1E",
    green5: "#00793A",
    gray2: "#7C7C7C"
}